import { styled } from "@mui/material";

export const Styled = {
    Container: styled("div")``,
    Data: styled("div")`
        display: flex;
        flex-direction: row;
        gap: 50px;
    `,
};
